import label from "@/lang/StaticLabels.js";

// PTAX Router  - سامانه مودیان ------------------------------------------------
let routeItems = {
  path: "PTAX",
  name: "PTAX",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PTAXDashboard" },
  children: [
    // ماژول هنوز داشبورد ندارد؛ صفحه ارسال فاکتور فروش صفحه اصلی آن است
    {
      path: "dashboard",
      name: "PTAXDashboard",
      redirect: { name: "PTAXSaleFactorInvoice" },
    },
    // Operation  -----------------------------------------------
    {
      path: "saleFactorInvoice",
      name: "PTAXSaleFactorInvoice",
      meta: {
        label: label.page.saleFactorInvoice,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/ptax/operation/saleFactorInvoice/index.vue"),
    },
    {
      path: "importExcel",
      name: "PTAXImportExcel",
      meta: {
        label: label.page.importExcelTaxInvoice,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/ptax/operation/importExcel/index.vue"),
    },
    {
      path: "invoice",
      name: "PTAXInvoice",
      meta: {
        label: label.page.taxInvoices,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/ptax/operation/invoice/index.vue"),
    },
    // Base Information  -----------------------------------------------
    {
      path: "key",
      name: "PTAXKey",
      meta: {
        label: label.page.taxKeys,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/ptax/basic/key/index.vue"),
    },
  ],
};

export default routeItems;
